<template>
  <div class="dialog" v-show="maskShow">
    <div class="tip">
      <span
        class="tipOne"
      >1：点击【继续下载】，下载后先使用 {{oldPhone}} 登录，登录后在【我的】--【设置】--【我的信息】--【电话】中，自行修改为新手机号。</span>
      <span
        class="tipTwo"
      >2：若找不回 {{oldPhone}} ，请您点击【去登记】提交信息，即可拿新号：{{currentPhone}}直接登录。但是无法同步旧账号的信息。</span>
    </div>
    <div class="btn">
      <button class="download" @click="download()">继续下载</button>
      <button class="register" @click="register()">去登记</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["maskShow", "employeeCode", "userName", "currentPhone", "oldPhone"],
  data() {
    return {};
  },
  methods: {
    download() {
      this.$router.push("/download");
    },
    register() {
      console.log(this.employeeCode, "employeeCode");
      this.$router.push({
        path: "/userInfo",
        query: {
          userName: this.userName,
          employeeCode: this.employeeCode,
          currentPhone: this.currentPhone
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog {
  height: 4.46rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.08rem;
  position: relative;
  z-index: 10;
  padding: 0.4rem 0.4rem 0rem 0.4rem;
  .tip {
    width: 6.11rem;
    height: 2.65rem;
    font-size: 0.28rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    position: relative;
    .tipOne {
      width: 100%;
      position: absolute;
      top: 0rem;
      left: 0rem;
      text-align: left;
    }
    .tipTwo {
      position: absolute;
      top: 1.7rem;
      left: 0rem;
      text-align: left;
    }
  }
  .btn {
    button {
      height: 1.2rem;
      background: rgba(255, 255, 255, 1);
      border: 0;
      font-size: 0.34rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 1.2rem;
      outline: none;
    }
    .download {
      width: 3.47rem;
      position: absolute;
      left: 0;
      bottom: 0;
      border-right: 0.02rem solid rgba(221, 221, 221, 1);
      border-top: 0.02rem solid rgba(221, 221, 221, 1);
      border-bottom-left-radius: 0.08rem;
      color: rgba(102, 102, 102, 1);
    }
    .register {
      width: 3.43rem;
      position: absolute;
      right: 0;
      bottom: 0;
      border-top: 0.02rem solid rgba(221, 221, 221, 1);
      border-bottom-right-radius: 0.08rem;
      color: rgba(50, 150, 250, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialogs.vue